import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flex from 'components/common/Flex';
import SubtleBadge from 'components/common/SubtleBadge';
import { useMenuBadge } from 'providers/MenuBadgeProvider';

const NavbarVerticalMenuItem = ({ route }) => {
  const { counters, lastUpdatedAt } = useMenuBadge();
  // Dynamic counter (route.counterKey='aml'|'kyc') имеет приоритет над
  // статичным route.badge. Если counterKey задан и > 0 — показываем число;
  // если 0 — бейдж скрывается, чтобы не отвлекать.
  const dynamicCount = route.counterKey ? counters[route.counterKey] : 0;
  const hasDynamic = route.counterKey && dynamicCount > 0;
  // AML-13 (v67): tooltip с временем последнего refresh. Оператор сразу
  // видит, насколько свежие данные в бейдже.
  const badgeTitle = lastUpdatedAt
    ? `Обновлено в ${lastUpdatedAt.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' })}`
    : 'Загрузка…';
  return (
    <Flex alignItems="center">
      {route.icon && (
        <span className="nav-link-icon">
          <FontAwesomeIcon icon={route.icon} />
        </span>
      )}
      <span className="nav-link-text ps-1">{route.name}</span>
      {hasDynamic && (
        // primary (синий) — нейтральный "есть работа". Жёлтый/красный
        // зарезервированы под warning/overdue (см. BA-review 2026-05-18).
        <SubtleBadge pill bg="primary" className="ms-2" title={badgeTitle}>
          {dynamicCount}
        </SubtleBadge>
      )}
      {!hasDynamic && route.badge && (
        <SubtleBadge pill bg={route.badge.type} className="ms-2">
          {route.badge.text}
        </SubtleBadge>
      )}
    </Flex>
  );
};

// prop-types
const routeShape = {
  active: PropTypes.bool,
  name: PropTypes.string.isRequired,
  to: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.array, PropTypes.string])
};
routeShape.children = PropTypes.arrayOf(PropTypes.shape(routeShape));
NavbarVerticalMenuItem.propTypes = {
  route: PropTypes.shape(routeShape).isRequired
};

export default React.memo(NavbarVerticalMenuItem);
